export default __webpack_public_path__ + "static/media/how-it-works-4.da1e124a.svg";